/**
 * This file is just the entry point for the JS compiler. No actual scripts 
 * should be defined here. It is basically just a loader for the files below.
 */

import './decision-tool.js';
import './decision-tool-financial.js';
import './screener.js';